// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"53422759","239":"4944061a","453":"b8670442","455":"c2d66316"}[chunkId] + ".chunk.js";
};